import React, { useState } from "react";
import "./Quiz.css";
import "../index.css"; // Import your CSS file here

// Sample data for questions
const questions = [
  {
    question: "What is the capital of France?",
    options: ["Berlin", "Madrid", "Paris", "Lisbon"],
    answer: "Paris",
  },
  {
    question: "Which planet is known as the Red Planet?",
    options: ["Earth", "Mars", "Jupiter", "Venus"],
    answer: "Mars",
  },
  {
    question: "What is 2 + 2?",
    options: ["3", "4", "5", "6"],
    answer: "4",
  },
  {
    question: "Who wrote 'Romeo and Juliet'?",
    options: ["Shakespeare", "Dickens", "Hemingway", "Austen"],
    answer: "Shakespeare",
  },
];

function App() {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [answered, setAnswered] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [quizFinished, setQuizFinished] = useState(false); // New state to track if quiz is finished

  const handleAnswerClick = (answer) => {
    if (answered) return; // Prevent answering again
    setSelectedAnswer(answer);
    if (answer === questions[currentQuestionIndex].answer) {
      setScore(score + 1);
    }
    setAnswered(true);
  };

  const handleNextQuestion = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setAnswered(false);
      setSelectedAnswer("");
    } else {
      setQuizFinished(true); // Mark the quiz as finished
    }
  };

  const handleRestartQuiz = () => {
    setCurrentQuestionIndex(0);
    setScore(0);
    setAnswered(false);
    setSelectedAnswer("");
    setQuizFinished(false); // Reset finished state
  };

  return (
    <div className="App">
      <div className="quiz-container">
        <h1 className="quiz-title">Quiz App</h1>
        <hr />
        {!quizFinished ? (
          <div className="question-container">
            <h2 className="question">{questions[currentQuestionIndex].question}</h2>
            <div className="options">
              {questions[currentQuestionIndex].options.map((option, index) => (
                <button
                  key={index}
                  onClick={() => handleAnswerClick(option)}
                  className={answered ? (option === selectedAnswer ? "selected" : "") : ""}
                >
                  {option}
                </button>
              ))}
            </div>
            {answered && (
              <button onClick={handleNextQuestion} className="next-btn">
                Next Question
              </button>
            )}
            <div className="score">
              <p>Score: {score}</p>
            </div>
          </div>
        ) : (
          <div className="result">
            <h2>Quiz Over!</h2>
            <p>Your score is: {score} / {questions.length}</p>
            <button onClick={handleRestartQuiz} className="restart-btn">
              Restart Quiz
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
